import { FC } from 'react';
import {
  Box,
  HStack,
  Text,
  SimpleGrid,
  Icon,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
  Button,
} from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

import { PhasesList } from '.';
import { formatDate } from '../../../utils';
import { multiplePhaseTabs } from '../utils';
import { ReactComponent as LocationIcon } from '../../../assets/projects/location.svg';
import { useGetProjectByIdQuery } from '../../../services';
import { CenteredSpinner } from '../../../components';

export const MultiplePhaseProjectDetails: FC = () => {
  const navigate = useNavigate();
  const { tabName, projectId } = useParams();

  const { data, isLoading } = useGetProjectByIdQuery(Number(projectId));

  let index = multiplePhaseTabs.findIndex(({ link }) => link === tabName);
  index = index === -1 ? 0 : index;

  return (
    <Tabs
      bg="white"
      position="relative"
      variant="unstyled"
      colorScheme="orange"
      index={index}
      onChange={tabIndex =>
        navigate(
          `/projects/multiple-phase/${projectId || '0'}/project-details/${
            multiplePhaseTabs[tabIndex].link
          }`
        )
      }
    >
      <TabList>
        {multiplePhaseTabs.map(({ name }) => (
          <Tab
            key={name}
            fontSize="sm"
            fontWeight="semibold"
            color="custom_gray.1"
            _selected={{ color: 'custom_orange.2' }}
          >
            {name}
          </Tab>
        ))}
      </TabList>
      <TabIndicator
        mt="-1.5px"
        height="2px"
        bg="custom_orange.2"
        borderRadius="1px"
      />
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <TabPanels>
          <TabPanel>
            <PhasesList />
          </TabPanel>
          <TabPanel>
            <VStack align="stretch" gap="4">
              <SimpleGrid columns={2} spacing={4}>
                <Box
                  borderRadius="md"
                  boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                  border="1px"
                  borderColor="custom_gray.3"
                  p="4"
                >
                  <VStack align="flex-start">
                    <Text
                      color="custom_blue.1"
                      fontSize="md"
                      fontWeight="bold"
                      mb="6"
                    >
                      Start Date
                    </Text>
                    <Text color="custom_blue.1" fontSize="md">
                      {formatDate(data?.data.calculatedStartDate as string)}
                    </Text>
                  </VStack>
                </Box>

                <Box
                  borderRadius="md"
                  boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                  border="1px"
                  borderColor="custom_gray.3"
                  p="4"
                >
                  <VStack align="flex-start">
                    <Text
                      color="custom_blue.1"
                      fontSize="md"
                      fontWeight="bold"
                      mb="6"
                    >
                      End Date
                    </Text>
                    <Text color="custom_blue.1" fontSize="md">
                      {formatDate(data?.data.calculatedEndDate as string)}
                    </Text>
                  </VStack>
                </Box>
              </SimpleGrid>

              {/* TODO: reuse after implementation */}
              {/* <Box
                borderRadius="md"
                boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                border="1px"
                borderColor="custom_gray.3"
                p="4"
              >
                <VStack align="flex-start">
                  <Text
                    color="custom_blue.1"
                    fontSize="md"
                    fontWeight="bold"
                    mb="4"
                  >
                    Progress
                  </Text>
                  <CustomProgress
                    value={data?.data.calculatedProgress as number}
                  />
                </VStack>
              </Box> */}

              <Box
                borderRadius="md"
                boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                border="1px"
                borderColor="custom_gray.3"
                p="4"
              >
                <VStack align="flex-start">
                  <Text
                    color="custom_blue.1"
                    fontSize="md"
                    fontWeight="bold"
                    mb="4"
                  >
                    Project Location
                  </Text>
                  <HStack justify="space-between" w="full">
                    <HStack>
                      <Icon as={LocationIcon} w="8" h="8" />
                      <VStack align="flex-start" gap=".5">
                        <Text
                          color="custom_blue.1"
                          fontWeight="semibold"
                          fontSize="lg"
                        >
                          {data?.data.area}
                        </Text>
                        <Text color="#2f3846" fontSize="sm">
                          {data?.data.country} {data?.data.city}{' '}
                          {data?.data.landMark}
                        </Text>
                      </VStack>
                    </HStack>
                    <Button
                      color="custom_blue.2"
                      fontSize="sm"
                      fontWeight="medium"
                      variant="outline"
                      bg="none"
                      _hover={{ bg: 'none' }}
                      borderRadius="full"
                      borderColor="custom_blue.3"
                    >
                      View On Map
                    </Button>
                  </HStack>
                </VStack>
              </Box>
            </VStack>
          </TabPanel>

          {/* TODO: reuse after implementation */}
          {/* <TabPanel>COMING SOON 🚀</TabPanel> */}
          {/* <TabPanel>COMING SOON 🚀</TabPanel> */}
        </TabPanels>
      )}
    </Tabs>
  );
};
